import { css } from "@emotion/css";
import useTheme from "@common/hooks/useTheme";

const useStyles = () => {
  const theme = useTheme();

  const wrapper = css`
    margin: 1rem;
    .row,
    .col {
      margin: 0;
    }
    .col {
      padding: 0;
    }
  `;

  // The page background is the layout's grey; nothing here inherits a heading
  // style from Rails, so the h1 carries its own typography rather than
  // relying on a global element rule.
  const title = css`
    ${theme.typography.h1}
    color: ${theme.colors.navy["1"]};
  `;

  const line = css`
    background-color: ${theme.colors.gray["2"]};
    margin: 1rem 0;
    width: 100%;
  `;

  const card = css`
    border-radius: 4px;
    border: 1px solid ${theme.colors.gray["2"]};
    background: ${theme.colors.white};
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.15);
    padding: 1.25em 1em;

    /* DataTable names each th "<camelCased column id>Col". Project names run
       long enough to wrap onto three lines at an even share of the table, so
       this column takes roughly double. */
    .projectNameCol {
      width: 22%;
    }
  `;

  const columnHeader = css`
    font-weight: 600;
  `;

  const sortableColumnHeader = css`
    font-weight: 600;
    cursor: pointer;
  `;

  const projectLink = css`
    color: ${theme.colors.teal["1"]};
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: ${theme.colors.teal["1"]};
      text-decoration: underline;
    }
  `;

  // The totals beside it describe only part of the project; this is the
  // sentence that stops a row reading as the whole picture.
  const caveat = css`
    font-size: 0.75rem;
    color: ${theme.colors.gray.primary};
  `;

  const empty = css`
    ${theme.typography.p}
    color: ${theme.colors.gray.primary};
    margin: 0;
  `;

  return {
    wrapper,
    title,
    line,
    card,
    columnHeader,
    sortableColumnHeader,
    projectLink,
    caveat,
    empty,
  };
};

export default useStyles;
